export const COMMON_FLAGS = {
    utm_source: {
        name: 'utm_source',
        description: 'This flag tracks the utm first source',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
    utm_medium: {
        name: 'utm_medium',
        description: 'This flag tracks the utm first medium',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
};
export const BLINK_FLAGS = {
    alwaysShowHelpCallouts: {
        name: 'alwaysShowHelpCallouts',
        description: 'If true, help callout bubbles are always shown',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    isAnswerV2Enabled: {
        name: 'isAnswerV2Enabled',
        description: 'If true, answer-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isKPIAnomaliesEnabled: {
        name: 'isKPIAnomaliesEnabled',
        description: 'If false, KPI Anomalies are globally disabled for the user',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isPinboardV2Enabled: {
        name: 'isPinboardV2Enabled',
        description: 'If true, pinboard-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSpotIQV2Enabled: {
        name: 'isSpotIQV2Enabled',
        description: 'If true, spotIQ-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    embedV2: {
        name: 'embedV2',
        description: 'If true, embed-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    disableRedirectToV1: {
        name: 'disableRedirectToV1',
        description: 'If true, data and admin tabs redirect to v2',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    restApiv2Enable: {
        name: 'restApiv2Enable',
        description: 'If true, restApiv2Enable would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    restApiv2Disable: {
        name: 'restApiv2Disable',
        description: 'If true, force disable restapi playground even if its enable in session service',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    isEverywhereEnabled: {
        name: 'isEverywhereEnabled',
        description: 'If true, TSE is enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    everywhereSettingLocked: {
        name: 'everywhereSettingLocked',
        description: 'If true, Everywhere Customizations will be locked',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableCrossSubDomainCookie: {
        name: 'enableCrossSubDomainCookie',
        description: 'If true, cross sub-domain cookies will be disabled for mixpanel',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    useLocalStorageForMixpanel: {
        name: 'useLocalStorageForMixpanel',
        description: 'If true, mixpanel will use local storage instead of cookies',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableABTesting: {
        name: 'enableABTesting',
        description: 'If true, mixpanel feature flags will be enabled for A/B testing',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSessionReplay: {
        name: 'enableSessionReplay',
        description: 'If true, mixpanel session replay will be enabled',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSparkflowUsecaseBasedOnboarding: {
        name: 'enableSparkflowUsecaseBasedOnboarding',
        description: "If true, Sparkflow's  usecase based onboarding will be enabled",
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableOnboardingQuestionChips: {
        name: 'enableOnboardingQuestionChips',
        description: 'If true, Sparkflow onboarding uses chip-based question screens',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    skipFreeTrialOnboardingSteps: {
        name: 'skipFreeTrialOnboardingSteps',
        description: 'If true, admins can skip onboarding steps while adding a user',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableOnboardingCSVUpload: {
        name: 'enableOnboardingCSVUpload',
        description: 'If true, Sparkflow onboarding shows datasource-selection screen to allow CSV upload',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSparkflowV2: {
        name: 'enableSparkflowV2',
        description: 'Enable Sparkflow V2 features including milestones, checklist updates, and its reorder',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showSparkflowTrialBannerInLiveboardEditPage: {
        name: 'showSparkflowTrialBannerInLiveboardEditPage',
        description: 'Show the Sparkflow trial banner in the Liveboard edit page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableFullUserJourney: {
        name: 'enableFullUserJourney',
        description: 'Enable full user journey feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableMultiWorksheet: {
        name: 'enableMultiWorksheet',
        description: 'Enable Spotter to use multi worksheets',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    tseRestApiV20PlaygroundEnabled: {
        name: 'tseRestApiV20PlaygroundEnabled',
        description: 'If true, user would be able to see the new Rest Api V2.0 playground',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    tseScheduleFeatureEnabled: {
        name: 'tseScheduleFeatureEnabled',
        description: 'If true, User will be able to create schedules for App Actions',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    tseStyleCustomisationsV2Enabled: {
        name: 'tseStyleCustomisationsV2Enabled',
        description: 'If true, User will be able to see the TSE style customisations knob',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    tseV2StyleApisEnabled: {
        name: 'tseV2StyleApisEnabled',
        description: 'If true, Style customizations page will use the new apis',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    tseMultipleAppActionEnabled: {
        name: 'tseMultipleAppActionEnabled',
        description: 'If true, User will be able to create multiple App Actions',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    hideRestV1Playground: {
        name: 'hideRestV1Playground',
        description: 'If true, hide rest v1 playground',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideGraphqlPlayground: {
        name: 'hideGraphqlPlayground',
        description: 'If true, hide graphql playground',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    exposeTranslationIDs: {
        name: 'exposeTranslationIDs',
        description: 'If true, exposed translate would be enabled',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    homeV2Experience: {
        name: 'homeV2Experience',
        description: 'If true, home-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    actionsUserGroupsEnabled: {
        name: 'actionsUserGroupsEnabled',
        description: 'If true, user should be able to enable user groups for actions',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    useLegacyEmbeddedPinboardActionConfig: {
        name: 'useLegacyEmbeddedPinboardActionConfig',
        description: 'If true, old list of standard actions will be available',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableMobileDeeplink: {
        name: 'disableMobileDeeplink',
        description: "If true, don't show open in app (deeplink) screen. We don't want to have this screen in embed",
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showCustomCalendarOption: {
        name: 'showCustomCalendarOption',
        description: 'To enbale/disable custion calendar option in data tab',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    neverShowHelpCallouts: {
        name: 'neverShowHelpCallouts',
        description: 'If true, help callout bubbles are never shown',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    alwaysShowTips: {
        name: 'alwaysShowTips',
        description: 'If true, tips are always shown',
        type: 'boolean',
        defaultValue: false,
        isListed: false,
    },
    neverShowTips: {
        name: 'neverShowTips',
        description: 'If true, tips are never shown',
        type: 'boolean',
        defaultValue: false,
        isListed: false,
    },
    debug: {
        name: 'debug',
        description: 'Enable features for debug mode',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    forceTraceSampling: {
        name: 'forceTraceSampling',
        description: 'Force 100% OTel trace sampling for this session, overriding the configured telemetrySampleRate. Still requires isFrontendTracingEnabled and telemetryEnabled.',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    debugJob: {
        name: 'debugJob',
        description: 'Add a cron schedule for jobs',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    disableChartTooltips: {
        name: 'disableChartTooltips',
        description: 'Disable chart tooltips',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    hideHomepageLeftNav: {
        name: 'hideHomepageLeftNav',
        description: 'This flag hides the homepage left nav-bar',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableAuthorNameSort: {
        name: 'disableAuthorNameSort',
        description: 'This flag hides the sorting of author and name in Liveboard and Answers in Homepage',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enablePbVizDataCaching: {
        name: 'enablePbVizDataCaching',
        description: 'This flag is used to enable the pb viz data caching',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    homepageUserCustomisationEnabled: {
        name: 'homepageUserCustomisationEnabled',
        description: 'This flag is used to customised the homepage ordering and visibilities.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    homepageVersion: {
        name: 'homepageVersion',
        description: 'This flag is used to check the homepage version',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    spotterExperience: {
        name: 'spotterExperience',
        description: "Override the cluster's Spotter experience",
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    listpageVersion: {
        name: 'listpageVersion',
        description: 'Represents the desired version of the list page.',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    enableAdvancedSerp: {
        name: 'enableAdvancedSerp',
        description: 'This flag is used to customise the SERP page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    serpVersion: {
        name: 'serpVersion',
        description: 'This flag is used to check the SERP version',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    monitorRuleAutoCreateEnabled: {
        name: 'monitorRuleAutoCreateEnabled',
        description: 'This flag is used to create monitor rule automatically',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    monitorRuleAutoCreateOptimizely: {
        name: 'monitorRuleAutoCreate',
        description: 'This optimisely flag is used to create monitor rule automatically',
        type: 'string',
        isListed: true,
        defaultValue: 'off',
    },
    scheduleJobAutoCreateEnabled: {
        name: 'scheduleJobAutoCreateEnabled',
        description: 'This flag is used to create schedule job automatically.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    scheduleJobAutoCreateOptimizely: {
        name: 'scheduleJobAutoCreate',
        description: 'This optimisely flag is used to create schedule job automatically',
        type: 'string',
        isListed: true,
        defaultValue: 'off',
    },
    flipTooltipToContextMenuEnabled: {
        name: 'flipTooltipToContextMenuEnabled',
        description: 'Enabled flipling the chart tooltip to context menu and visual changes.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    contextMenuEnabledOnWhichClick: {
        name: 'contextMenuEnabledOnWhichClick',
        description: 'Enabled context menu opens on which click either left, right or both',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    tagManagementEnabled: {
        name: 'tagManagementEnabled',
        description: 'Enabled tag management for admin & can manage tag role.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableHomeWatchlist: {
        name: 'enableHomeWatchlist',
        description: 'This flag is used to enable the homepage watchlist 9.12 onwards',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableWatchlistV2: {
        name: 'enableWatchlistV2',
        description: 'This flag is used to enable the homepage watchlist v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableHtmlSanitisation: {
        name: 'enableHtmlSanitisation',
        description: 'This flag is used to enable HTML Sanitisation in Liveboard input fields',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    blockNonEmbedFullAppAccess: {
        name: 'blockNonEmbedFullAppAccess',
        description: 'Disable Full App access from iFrame to a new tab',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableLoginRedirect: {
        name: 'disableLoginRedirect',
        description: 'Disable Login Redirect',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    disableSAMLAutoRedirect: {
        name: 'disableSAMLAutoRedirect',
        description: 'Override the system configuration to auto redirect to SAML login',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    spotIqObjectTablePageEnabled: {
        name: 'spotIqObjectTablePageEnabled',
        description: 'This flag is used to enable the spotiq object table page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableListTablePages: {
        name: 'enableListTablePages',
        description: 'This flag is used to enable the list table pages',
        type: 'json',
        isListed: true,
        defaultValue: undefined,
    },
    forceSAMLAutoRedirect: {
        name: 'forceSAMLAutoRedirect',
        description: 'Force SAML Redirect',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    disableTransformationsInVizEmbeds: {
        name: 'disableTransformationsInVizEmbeds',
        description: 'Override the system configuration to enable/disable transformations in ' +
            'embedded vizes and pinboards',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    embedApp: {
        name: 'embedApp',
        description: 'This flag enables full embed app',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableAnalyzeMode: {
        name: 'enableAnalyzeMode',
        description: 'Whether to show analyze mode for objects like worksheet.',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableCJA: {
        name: 'enableCJA',
        description: 'Flag to enable Customer Journey Analysis',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    vizRenderScrollDebounceMs: {
        name: 'vizRenderScrollDebounceMs',
        description: 'Debounce time in milliseconds for viz render scroll',
        type: 'number',
        isListed: true,
        defaultValue: 0,
    },
    loadContextBookAPIDebounceMs: {
        name: 'loadContextBookAPIDebounceMs',
        description: 'Debounce time in milliseconds for load context book API',
        type: 'number',
        isListed: true,
        defaultValue: 0,
    },
    enableViewportAwareVizRender: {
        name: 'enableViewportAwareVizRender',
        description: 'Enable viewport aware viz rendering for better performance',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableGlobalNav: {
        name: 'enableGlobalNav',
        description: 'Flag to enable global navigation',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    discoverabilityCheckboxUnselectedPerOrg: {
        name: 'discoverabilityCheckboxUnselectedPerOrg',
        description: 'This flag disables content discoverability modal checkbox by default',
        type: 'object',
        isListed: true,
        defaultValue: undefined,
    },
    nlsFeedbackLearnabilityUiEnabled: {
        name: 'nlsFeedbackLearnabilityUiEnabled',
        description: 'This flag enables nls feedback learnability on UI',
        type: 'object',
        isListed: true,
        defaultValue: undefined,
    },
    isSpotterExperienceEnabled: {
        name: 'isSpotterExperienceEnabled',
        description: 'This flag enable spotter experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isStarterPromptsEnabled: {
        name: 'isStarterPromptsEnabled',
        description: 'Enables the Spotter Starter Prompts library UI',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSpotterDataSourceDiscovery: {
        name: 'enableSpotterDataSourceDiscovery',
        description: 'flag enable spotter data source discovery',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isNLInstructionsInSpotterEnabled: {
        name: 'isNLInstructionsInSpotterEnabled',
        description: 'Flag to enable NL instruction in spotter',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    showSpotterPastConversations: {
        name: 'showSpotterPastConversations',
        description: 'Flag to enable/disable showing past conversations in Spotter',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSpotEnabled: {
        name: 'isSpotEnabled',
        description: 'Flag to enable/disable the Spots feature (custom AI mini agents)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableLLMGatewayV2: {
        name: 'enableLLMGatewayV2',
        description: 'Flag to enable/disable LLM Gateway V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableBYOLLM: {
        name: 'enableBYOLLM',
        description: 'Flag to enable/disable BYO LLM',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isFeedbackMigrationEnabled: {
        name: 'isFeedbackMigrationEnabled',
        description: 'This flag enables feedback migration',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAddToCoachingFromChatEnabled: {
        name: 'isAddToCoachingFromChatEnabled',
        description: 'This flag enable add to coaching from chat',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isMemoryEnabledInSpotter: {
        name: 'isMemoryEnabledInSpotter',
        description: 'This flag enable memory in spotter',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isUserPreferencesMemoryEnabled: {
        name: 'isUserPreferencesMemoryEnabled',
        description: 'This flag enables user preferences memory in spotter',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isMemorySourcesEnabled: {
        name: 'isMemorySourcesEnabled',
        description: 'Enable memory sources page in data model nav',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    isMCPAdminConnectorsEnabled: {
        name: 'isMCPAdminConnectorsEnabled',
        description: 'This flag enables MCP Admin connectors configuration',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    updatedSpotterChatPrompt: {
        name: 'updatedSpotterChatPrompt',
        description: 'This flag enables Updated Spotter chat prompt configuration',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    resetPasswordV2Enabled: {
        name: 'resetPasswordV2Enabled',
        description: 'This flag enables reset password v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    orgStatisticsCountV2Enabled: {
        name: 'orgStatisticsCountV2Enabled',
        description: 'This flag enables org statistics count v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAnswers: {
        name: 'enableAnswers',
        description: 'This flag enables saved answers behaviour',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    instantSearch: {
        name: 'instantSearch',
        description: 'This flag enables instant search (and thus disables search on enter)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableParameters: {
        name: 'enableParameters',
        description: 'Enables parameters in search data',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableParametersDynamicDate: {
        name: 'enableParametersDynamicDate',
        description: 'Enables parameters to use dynamic date values',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSageTokenContextMenu: {
        name: 'enableSageTokenContextMenu',
        description: 'Enables the new context menu for sage tokens',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableNavigationModalPopupForUnsavedAnswer: {
        name: 'enableNavigationModalPopupForUnsavedAnswer',
        description: 'Enables navigation Modal Popup when user navigates from search data page with unsaved changes',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableShareDebugArtifacts: {
        name: 'enableShareDebugArtifacts',
        description: 'Enables Report Issue feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAdvancedCohortGroupsBins: {
        name: 'enableAdvancedCohortGroupsBins',
        description: 'Enable advanced cohort groups/bins support',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCohortsOnSystemWorksheets: {
        name: 'enableCohortsOnSystemWorksheets',
        description: 'Enable simple/advanced cohort on system worksheets',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCallosumDebugInfo: {
        name: 'enableCallosumDebugInfo',
        description: 'Enable Callosum Debug Info',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    objectSearchResult: {
        name: 'objectSearchResult',
        description: 'This flag enables object search result',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableSnapshotCapture: {
        name: 'enableSnapshotCapture',
        description: 'This flag enables snapshot capture on answer and pinboard',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableSnapshotCaptureForAnswerV2: {
        name: 'enableSnapshotCaptureForAnswerV2',
        description: 'This flag enables snapshot capture answer v2',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableEurekaAdvancedTypeahead: {
        name: 'enableEurekaAdvancedTypeahead',
        description: 'This flag enables advanced typeahead w/ query suggesitons',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableEurekaTypeaheadRecentObjects: {
        name: 'enableEurekaTypeaheadRecentObjects',
        description: 'This flag enables recent objects in eureka typeahead',
        type: 'object',
        isListed: true,
        defaultValue: undefined,
    },
    exploreMeasureFiltersEnabled: {
        name: 'exploreMeasureFiltersEnabled',
        description: '',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableEurekaSearch: {
        name: 'enableEurekaSearch',
        description: 'This flag enables Eureka search',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    edgeEnabled: {
        name: 'edgeEnabled',
        description: 'This flag enables edge onbaording',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    sparkFlowEnabled: {
        name: 'sparkFlowEnabled',
        description: 'Flag to determine whether spark flow is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    copilotEnabled: {
        name: 'copilotEnabled',
        description: 'This flag enables copilot',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    navigationVersion: {
        name: 'navigationVersion',
        description: 'This flag enables navigation version v3',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    edgeOnboardingIntroVideoSeen: {
        name: 'edgeOnboardingIntroVideoSeen',
        description: 'This flag enables edge onboarding intro video',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    edgeOnboardingCompleted: {
        name: 'edgeOnboardingCompleted',
        description: 'This flag enables edge onboarding completed state',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    edgeOnboardingPersonalInfoFilled: {
        name: 'edgeOnboardingPersonalInfoFilled',
        description: 'This flag enables edge onboarding personal info filled state',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hasSeenCopilotOnboarding: {
        name: 'hasSeenCopilotOnboarding',
        description: 'Flag to know if the user has seen copilot onboarding',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableOptimizely: {
        name: 'enableOptimizely',
        description: 'This flag enables optimizely',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableEurekaWorksheetDisablement: {
        name: 'enableEurekaWorksheetDisablement',
        description: 'This flag enables discoverability features for Eureka',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableEurekaSynonymWorkflow: {
        name: 'enableEurekaSynonymWorkflow',
        description: 'This flag enables synonym workflow for Eureka',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableEurekaDebugInfo: {
        name: 'enableEurekaDebugInfo',
        description: 'This flag enables eureka debug info which can be shown with results',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    primaryNavHidden: {
        name: 'primaryNavHidden',
        description: 'This flag shows primary nav',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    applicationSwitcherHidden: {
        name: 'applicationSwitcherHidden',
        description: 'This flag hides application switcher',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideHamburger: {
        name: 'hideHamburger',
        description: 'This flag hides hambuger icon on the global top nav',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideNotification: {
        name: 'hideNotification',
        description: 'This flag hides notification on the global top nav',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideObjectSearch: {
        name: 'hideObjectSearch',
        description: 'This flag hides eureke search icon on the global top nav',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideOrgSwitcherUi: {
        name: 'hideOrgSwitcherUi',
        description: 'Flag to enable/disable org switcher in UI',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    orgSwitcherHidden: {
        name: 'orgSwitcherHidden',
        description: 'This flag hides org switcher',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    profileAndHelpInNavBarHidden: {
        name: 'profileAndHelpInNavBarHidden',
        description: 'Hides the profile and help options in the primary nav in full embed',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCustomRegion: {
        name: 'enableCustomRegion',
        description: 'Enables ability to select custom region in geo config setting',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableFormulae: {
        name: 'enableFormulae',
        description: 'This flag enables formulae',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    showAutoGeneratedFormulas: {
        name: 'showAutoGeneratedFormulas',
        description: 'This flag controls whether auto-generated formulas are displayed',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enablePinboardSnapshots: {
        name: 'enablePinboardSnapshots',
        description: 'This flag enables pinboard snapshotting in the UI',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableQoQ: {
        name: 'enableQoQ',
        description: 'This flag enables query on query',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableAnswerPageInsights: {
        name: 'enableAnswerPageInsights',
        description: 'This flag enables Related Insights on the answer page',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enablePivotContextMenu: {
        name: 'enablePivotContextMenu',
        description: 'This flag enables TS context menu for PIVOT TABLE',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enablePinboardMetadataExecutiveSummary: {
        name: 'enablePinboardMetadataExecutiveSummary',
        description: 'This flag enables Executive Summary on the pinboard metadata',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableHomepageInsights: {
        name: 'enableHomepageInsights',
        description: 'This flag enables Did you know? Insights on the homepage',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableInlineSpotIq: {
        name: 'enableInlineSpotIq',
        description: 'This flag enables inline SpotIQ analysis on answer page',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableOutOfScopeMatches: {
        name: 'enableOutOfScopeMatches',
        description: '',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableSageUserFeedback: {
        name: 'enableSageUserFeedback',
        description: 'This flag enables SageUserFeedback',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableTableColumnHeaderMenu: {
        name: 'enableTableColumnHeaderMenu',
        description: 'If true, user should see a table column header button which can be ' +
            'clicked to show a menu containing filters or other column level operations',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableTraceDownloads: {
        name: 'enableTraceDownloads',
        description: 'enable trace download',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableWebGLMaps: {
        name: 'enableWebGLMaps',
        description: 'Enables option of WebGL geo maps.',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableGeomapDblClickZoom: {
        name: 'enableGeomapDblClickZoom',
        description: 'Enables double click to zoom with geo maps.',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableDoubleClickDrillDown: {
        name: 'enableDoubleClickDrillDown',
        description: 'Toggles auto-drill-down when double-clicking data points.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    matchValues: {
        name: 'matchValues',
        description: 'returns boolean value, whether to send filter values to callosum ' +
            'for verification',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    geoTileSourceId: {
        name: 'geoTileSourceId',
        description: 'This flag enables loading of image tiles in geomaps based on ' +
            'the value of the flag',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    geoTileType: {
        name: 'geoTileType',
        description: 'This flag sets the type of tile imager loaded from the source id ' +
            'specified via `geoTileSourceId` flag',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    mapboxAccessToken: {
        name: 'mapboxAccessToken',
        description: 'stores the access token from mapbox that can be used for mapbox api calls',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
    locale: {
        name: 'locale',
        description: 'This flag overrides any preferred locales',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
    dateFormatLocale: {
        name: 'dateFormatLocale',
        description: 'This flag overrides default/user preffered locale for date formatting',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    numberFormatLocale: {
        name: 'numberFormatLocale',
        description: 'This flag overrides default/user preffered locale for number formatting',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    currencyFormat: {
        name: 'currencyFormat',
        description: 'This flag overrides the browser locale for currency formatting',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    metadataBatchSize: {
        name: 'metadataBatchSize',
        description: 'Size of each page on metadata list pages',
        type: 'number',
        isListed: true,
        defaultValue: 20,
    },
    queryUpdateDebounceThreshold: {
        name: 'queryUpdateDebounceThreshold',
        description: 'Threshold to wait for query changes to settle ' +
            'before system tries to fetch answer',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    restrictSearchHelp: {
        name: 'restrictSearchHelp',
        description: 'Test flag to set/unset this cluster state',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    openVizUrlInSameTab: {
        name: 'openVizUrlInSameTab',
        description: 'Opens formatted url in data viz in the same tab',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    maxConcurrentDataCalls: {
        name: 'maxConcurrentDataCalls',
        description: 'Number of concurrent data calls on a pinboard page',
        type: 'number',
        isListed: true,
        defaultValue: null,
    },
    sageSnapshotRequest: {
        name: 'sageSnapshotRequest',
        description: 'This flag enables writing of snapshot file for a request',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    screenshotMode: {
        name: 'screenshotMode',
        description: 'This flag enables snapshot mode',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    showRelatedItems: {
        name: 'showRelatedItems',
        description: 'Whether to show related Items',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    showRelatedLinks: {
        name: 'showRelatedLinks',
        description: 'Whether to show related Links only',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    suppressNaHeadlines: {
        name: 'suppressNaHeadlines',
        description: 'If true, anytime there is a N/A headline it will be suppressed',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    trackPerformance: {
        name: 'trackPerformance',
        description: 'Enables performance metric tracking when set to true',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    useBachWorksheetModel: {
        name: 'useBachWorksheetModel',
        description: 'use bach worksheet model',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    useLogicalTablePreview: {
        name: 'useLogicalTablePreview',
        description: 'use logical table preview and bach APIs',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableHelp: {
        name: 'enableHelp',
        description: 'This flag enables help',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableSearchHistory: {
        name: 'enableSearchHistory',
        description: 'This flag enables search history',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enablePerformanceCapture: {
        name: 'enablePerformanceCapture',
        description: 'This flag enables the UI to capture performance',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableWootric: {
        name: 'enableWootric',
        description: 'This flag enables Wootric',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableSessionRecording: {
        name: 'enableSessionRecording',
        description: 'This flag enables video recording the user session',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableEmptySearchPageInsights: {
        name: 'enableEmptySearchPageInsights',
        description: 'This flag enables insights on empty search page',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    adminPortal: {
        name: 'adminPortal',
        description: 'This flag redirects Admin tab to managementportal',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableEnlite: {
        name: 'enableEnlite',
        description: 'This flag enables natural language querying',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableExplore: {
        name: 'enableExplore',
        description: 'Allows the user to expand a pinboard card and perform incremental changes',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableUBR: {
        name: 'disableUBR',
        description: 'This flag disables UBR for enlite queries',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableWorksheetFilters: {
        name: 'enableWorksheetFilters',
        description: 'This flag turns on the worksheet filters features',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableFollowTestData: {
        name: 'enableFollowTestData',
        description: 'For allowing generation of test data for follow feature',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableFollowV2: {
        name: 'enableFollowV2',
        description: 'For enabling follow v2 feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    vizSnapshotEnabled: {
        name: 'vizSnapshotEnabled',
        description: 'This flag enable/disable viz snapshot feature',
        type: 'boolean',
        isListed: true,
        defaultValue: null,
    },
    hideDataTabOnNoManageDataPermission: {
        name: 'hideDataTabOnNoManageDataPermission',
        description: 'This flag hides data tab when user ' +
            'does not have permission to manage data',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableManageMCPConnectorPermissions: {
        name: 'enableManageMCPConnectorPermissions',
        description: 'Enables the manage permissions in connectors',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableMCPConnectorSharing: {
        name: 'enableMCPConnectorSharing',
        description: 'Enables sharing governance for MCP connectors',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableConnectorMarketplace: {
        name: 'enableConnectorMarketplace',
        description: 'Shows the new connector marketplace page instead of the ' +
            'existing admin connectors page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSyncEnabled: {
        name: 'isSyncEnabled',
        description: 'Enable sync functionalities of embrace',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    signUpEnabled: {
        name: 'signUpEnabled',
        description: 'This flag enables Sign up Button',
        type: 'boolean',
        isListed: true,
        defaultValue: null,
    },
    gzipSavePinboardRequest: {
        name: 'gzipSavePinboardRequest',
        description: 'This flag enables compression of post request',
        type: 'boolean',
        isListed: false,
        defaultValue: null,
    },
    signUpButtonLink: {
        name: 'signUpButtonLink',
        description: 'This flag configures the endpoint of Sign Up Button',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    signUpButtonText: {
        name: 'signUpButtonText',
        description: 'This flag configures the Sign Up Button Text',
        type: 'string',
        isListed: true,
        defaultValue: null,
    },
    dataBatchSize: {
        name: 'dataBatchSize',
        description: 'Max number of data points to fetch in callosum data api call',
        type: 'number',
        isListed: true,
        defaultValue: 0,
    },
    maxPinboardTableDataBatchSize: {
        name: 'maxPinboardTableDataBatchSize',
        description: 'Max number of data points to fetch in callosum data api call',
        type: 'number',
        isListed: true,
        defaultValue: 0,
    },
    userGroupCount: {
        name: 'userGroupCount',
        description: 'Number of groups to be displayed for a user',
        type: 'number',
        isListed: true,
        defaultValue: 100,
    },
    maxChartLegendCardinality: {
        name: 'maxChartLegendCardinality',
        description: 'Maximum number of distinct data values supported in charts',
        type: 'number',
        isListed: true,
        defaultValue: 250,
    },
    maxLabelCount: {
        name: 'maxLabelCount',
        description: 'Maximum number of data-label points beyond which ' +
            'labels will not be displayed',
        type: 'number',
        isListed: true,
        defaultValue: 1000,
    },
    isCustomLabelProcessingDisabled: {
        name: 'isCustomLabelProcessingDisabled',
        description: 'When true AND the browser reports prefers-reduced-motion: ' +
            'reduce, skip ThoughtSpot custom cross-type data-label overlap ' +
            'detection (postProcessHighchartDataLabels) and defer to ' +
            'Highcharts built-in hideOverlappingLabels. NOTE: the URL ' +
            'override (?isCustomLabelProcessingDisabled=true) only takes ' +
            'effect when the OS also has reduced-motion enabled.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    responsiveLayoutDefault: {
        name: 'responsiveLayoutDefault',
        description: 'Sets responsiveLayout to the value of this flag if value is not userdefined',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    tableAggregate: {
        name: 'tableAggregate',
        description: 'Add Table Aggregate option to headline',
        type: 'number',
        isListed: true,
        defaultValue: 0,
    },
    scriptability: {
        name: 'scriptability',
        description: 'Allow user to import/export answer/pinboard/worksheet from/to file',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    chartAnimations: {
        name: 'chartAnimations',
        description: 'Should chart show animation while rendering',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableChartConfigV2: {
        name: 'enableChartConfigV2',
        description: 'Show new chart configurator',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    disableRandomColor: {
        name: 'disableRandomColor',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    e2eTest: {
        name: 'e2eTest',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    fakeApi: {
        name: 'fakeApi',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    shouldUseGetEncoding: {
        name: 'shouldUseGetEncoding',
        description: '',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    urlEncodingBasePath: {
        name: 'urlEncodingBasePath',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: '/base64url',
    },
    shouldValidateGetRequestForBannedCharacters: {
        name: 'shouldValidateGetRequestForBannedCharacters',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    base64UrlEncodedFlags: {
        name: 'base64UrlEncodedFlags',
        description: 'Url flag to pass base 64 encoded url flags for embed scenarios',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
    callosumBasePath: {
        name: 'callosumBasePath',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: '/callosum/v1',
    },
    sageBasePath: {
        name: 'sageBasePath',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: '/sage/',
    },
    sageBasePathV2: {
        name: 'sageBasePathV2',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: '/complete/',
    },
    batchSize: {
        name: 'batchSize',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: '',
    },
    iconSprite: {
        name: 'iconSprite',
        description: 'Provide a custom icon sprite',
        type: 'string',
        isListed: false,
        defaultValue: '',
    },
    tableVizOnly: {
        name: 'tableVizOnly',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    deadlineMs: {
        name: 'deadlineMs',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 0,
    },
    queryDeadlineMs: {
        name: 'queryDeadlineMs',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 0,
    },
    deadlineExplorerMs: {
        name: 'deadlineExplorerMs',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 300000,
    },
    allowPartialResults: {
        name: 'allowPartialResults',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    allowPartialResultsExplorer: {
        name: 'allowPartialResultsExplorer',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    maxItemsInSageCache: {
        name: 'maxItemsInSageCache',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 5,
    },
    maxSageCompletions: {
        name: 'maxSageCompletions',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 20,
    },
    sageTimeout: {
        name: 'sageTimeout',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 20000,
    },
    a3Timeout: {
        name: 'a3Timeout',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 300000,
    },
    sageNetworkBudget: {
        name: 'sageNetworkBudget',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 200,
    },
    bachTimeout: {
        name: 'bachTimeout',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 600000,
    },
    callosumTimeout: {
        name: 'callosumTimeout',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 300000,
    },
    disableResponsiveTiles: {
        name: 'disableResponsiveTiles',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: false,
    },
    onDemandFilter: {
        name: 'onDemandFilter',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    disableSuccessNotificationAutoHide: {
        name: 'disableSuccessNotificationAutoHide',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    successAlertHidingDelay: {
        name: 'successAlertHidingDelay',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 4000,
    },
    confirmPinboardVizRemoval: {
        name: 'confirmPinboardVizRemoval',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    minTableColumnWidth: {
        name: 'minTableColumnWidth',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 120,
    },
    attributeFilterMaxValues: {
        name: 'attributeFilterMaxValues',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 100,
    },
    maxNumFilterValuesInModal: {
        name: 'maxNumFilterValuesInModal',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 500,
    },
    attributeFilterSearchDelay: {
        name: 'attributeFilterSearchDelay',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 100,
    },
    basicMode: {
        name: 'basicMode',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    keywordCompletions: {
        name: 'keywordCompletions',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    disableAppTourOnOlderIE: {
        name: 'disableAppTourOnOlderIE',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    enableAppTour: {
        name: 'enableAppTour',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    clientLogLevel: {
        name: 'clientLogLevel',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: 'WARN',
    },
    currentEpochOverrideMs: {
        name: 'currentEpochOverrideMs',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 0,
    },
    enableSageRequestProfile: {
        name: 'enableSageRequestProfile',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    numTokensThresholdForSmallDropdown: {
        name: 'numTokensThresholdForSmallDropdown',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 3,
    },
    maxNumCompletionsInSage: {
        name: 'maxNumCompletionsInSage',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 5,
    },
    showViewMoreOptionInDropdown: {
        name: 'showViewMoreOptionInDropdown',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    minWaitTimeBeforeRendering: {
        name: 'minWaitTimeBeforeRendering',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 500,
    },
    filterThrottlingDelay: {
        name: 'filterThrottlingDelay',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 750,
    },
    enableFilterSlider: {
        name: 'enableFilterSlider',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    maxColumnsAllowedInQuery: {
        name: 'maxColumnsAllowedInQuery',
        description: '',
        type: 'number',
        isListed: false,
        defaultValue: 100,
    },
    forceWorksheetUpgrade: {
        name: 'forceWorksheetUpgrade',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    defaultLocale: {
        name: 'defaultLocale',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    customBrandingEnabled: {
        name: 'customBrandingEnabled',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    customBrandingFontCustomizationEnabled: {
        name: 'customBrandingFontCustomizationEnabled',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    ignoreCache: {
        name: 'ignoreCache',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableQueryMerging: {
        name: 'enableQueryMerging',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableHomeDashboard: {
        name: 'enableHomeDashboard',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    scenarios: {
        name: 'scenarios',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    dev: {
        name: 'dev',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    enableUnsavedChangesAlert: {
        name: 'enableUnsavedChangesAlert',
        description: '',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    answerDisplayMode: {
        name: 'answerDisplayMode',
        description: '',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    downloadAnnotationText: {
        name: 'downloadAnnotationText',
        description: 'String to control the download object annotations.',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    addNullFilterSuggestion: {
        name: 'addNullFilterSuggestion',
        description: 'Add null filter value suggestion on filter modal',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showOnboarding: {
        name: 'showOnboarding',
        description: 'Takes the user through on-boarding after they are log in',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showCloudBusinessOnboarding: {
        name: 'showCloudBusinessOnboarding',
        description: 'Enabled cloud business onboarding',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hasSeenOnboarding: {
        name: 'hasSeenOnboarding',
        description: 'Flag to know if the user has seen onboarding or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isFirstLogin: {
        name: 'isFirstLogin',
        description: 'flag to determine if this the first login of the user',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableJoinsSchemaGraphViewer: {
        name: 'enableJoinsSchemaGraphViewer',
        description: 'Show joins schema graph viewer side by side with joins',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableColumnRename: {
        name: 'enableColumnRename',
        description: 'Enable rename option for columns in charts/tables',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    showRamdisk: {
        name: 'showRamdisk',
        description: 'This flag enables ramdisk column for table-view in adminUI',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    disableTSBrandingInPDF: {
        name: 'disableTSBrandingInPDF',
        description: 'This flag disables TS logo in cover page of PDF export',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableICT: {
        name: 'enableICT',
        description: 'Flag that enables in context translations mode using the crowdin plugin',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    ictProjectName: {
        name: 'ictProjectName',
        description: 'Name of the exact project for which in context translations are enabled',
        type: 'string',
        isListed: true,
        defaultValue: 'blinkincontext',
    },
    useBachAnswer: {
        name: 'useBachAnswer',
        description: 'Use Bach Answer APIs',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enablePendo: {
        name: 'enablePendo',
        description: 'Flag to enable/disable pendo',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enablePendoHelp: {
        name: 'enablePendoHelp',
        description: 'Flag to enable/disable pendo help',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    searchAssist: {
        name: 'searchAssist',
        description: 'Show dialog to guide user through the process of using search',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    searchAssistExperiments: {
        name: 'search_assist_experiments',
        description: 'Set number of lessons to show in search assist',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    liveboardV2Guide: {
        name: 'isPinboardGuideEnable',
        description: 'Show guide for liveboard for explore, edit and download',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    uplevelMakeACopy: {
        name: 'isUplevelMakeACopyEnabled',
        description: 'Show Make a copy button outside the dropdown',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    requestAccessExperiment: {
        name: 'isRequestAccessExperimentEnabled',
        description: 'To enable request access experiment on liveboard page',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    freeTrialAnalystOptions: {
        name: 'isAnalystOptionsVisible',
        description: 'Show 3 way screen on user onboarding for free Trial',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    searchAssistTotalAccessibleLessons: {
        name: 'search_assist_total_accessible_lessons',
        description: 'Set number of lessons to show in search assist',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    enableVizSharing: {
        name: 'enableVizSharing',
        description: 'Flag to enable/disable Viz Sharing',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableVizSharingWithLink: {
        name: 'enableVizSharingWithLink',
        description: 'Flag to enable/disable Viz Sharing with link',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableShareOnSlack: {
        name: 'enableShareOnSlack',
        description: 'Flag to enable/disable Share on Slack',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableDataSourceShareBySharer: {
        name: 'enableDataSourceShareBySharer',
        description: 'Flag to enable/disable data source sharing by sharer',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableRequestAccess: {
        name: 'enableRequestAccess',
        description: 'Flag to enable/disable request access',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    userPersona: {
        name: 'userPersona',
        description: 'Flag to determine user persona',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    demoWorksheetGuids: {
        name: 'demoWorksheetGuids',
        description: 'Flag to provide demo worksheet guids',
        type: 'string',
        isListed: true,
        defaultValue: '',
    },
    enableAnalystOnboarding: {
        name: 'enableAnalystOnboarding',
        description: 'Flag to enable/disable Analyst Onboarding',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableDataManagementCheck: {
        name: 'enableDataManagementCheck',
        description: 'Flag to enable/disable Data Management Check for Persona Identification',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableProfileInTable: {
        name: 'enableProfileInTable',
        description: 'Flag to enable/disable profile tab',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableTrialCluster: {
        name: 'enableTrialCluster',
        description: 'Flag to enable trial cluster mode',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    totalTrialDays: {
        name: 'totalTrialDays',
        description: 'Flag to assign number of total trial days for user',
        type: 'number',
        isListed: false,
        defaultValue: undefined,
    },
    trialDaysLeft: {
        name: 'trialDaysLeft',
        description: 'Flag to assign number of trial days left for user',
        type: 'number',
        isListed: false,
        defaultValue: undefined,
    },
    synonymGenerationEnabled: {
        name: 'synonymGenerationEnabled',
        description: 'Flag to check if synonym generation is enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    autoGenerateSynonymsOnSave: {
        name: 'autoGenerateSynonymsOnSave',
        description: 'Flag to check if auto generation of synonyms on Save is enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    createV1AndV2Worksheet: {
        name: 'createV1AndV2Worksheet',
        description: 'Flag to check if worksheet V1 and V2 both are enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    worksheetV2DefaultEnabled: {
        name: 'worksheetV2DefaultEnabled',
        description: 'Flag to check if worksheet V2 is enabled by default',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    convertToModel: {
        name: 'convertToModel',
        description: 'Setting this flag convert V1 worksheet to V2 worksheet',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    syncIndexSettingWithSource: {
        name: 'syncIndexSettingWithSource',
        description: 'Setting this flag disbale  suggestion for index setting',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    dropQuestionOnWorksheetPage: {
        name: 'dropQuestionOnWorksheetPage',
        description: 'Drop question details on worksheet Detail page',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableV2KnowledgeCard: {
        name: 'enableV2KnowledgeCard',
        description: 'This flage enables Knowledge card in worksheet-v2',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSlackDisconnectedBanner: {
        name: 'enableSlackDisconnectedBanner',
        description: 'This flag enables Slack Disconnected banner',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    tmlTableRemappingEnabled: {
        name: 'tmlTableRemappingEnabled',
        description: 'Flag to check if table tml remapping is enabled.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isTmlUtilityV2Enabled: {
        name: 'isTmlUtilityV2Enabled',
        description: 'Flag to enable new UI for TML export and import',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    webpageMetrics: {
        name: 'webpageMetrics',
        description: 'Enable the in-app webpage metrics tool',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableCacheCleanup: {
        name: 'enableCacheCleanup',
        description: 'Enable apollo cache cleanup on page navigation',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    connectionTMLSupportEnabled: {
        name: 'connectionTMLSupportEnabled',
        description: 'Flag to check if connection TML is enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableJoinRecommendations: {
        name: 'enableJoinRecommendations',
        description: 'Flag to check if join recommendation is enabled',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableReactWorksheet: {
        name: 'enableReactWorksheet',
        description: 'Flag to enable react version of schema viewer',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMetadataDetailsInReact: {
        name: 'enableMetadataDetailsInReact',
        description: 'Flag to enable react version of schema details page',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    schemaDetailsJoinInReact: {
        name: 'schemaDetailsJoinInReact',
        description: 'Flag to enable react version of schema details join tab',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableReactSchemaViewer: {
        name: 'enableReactSchemaViewer',
        description: 'Flag to enable schema viewer in utilities page in react',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableColumnsCsvImportExport: {
        name: 'enableColumnsCsvImportExport',
        description: 'Flag to enable columns import export csv in columns tab',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableColumnAlias: {
        name: 'enableColumnAlias',
        description: 'Flag to enable column alias in workhseet details page',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableColumnAliasUdf: {
        name: 'enableColumnAliasUdf',
        description: 'Flag to enable column alias UDF functionality in TML options',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableNonEquiJoinInUI: {
        name: 'enableNonEquiJoinInUI',
        description: 'Flag to enable non-equi joins in worksheet join builder UI',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableColumnDependencyDeletion: {
        name: 'enableColumnDependencyDeletion',
        description: 'Flag to enable column dependency delete',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableAiModeling: {
        name: 'enableAiModeling',
        description: 'Flag to enable AI Modeling',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    joinAllowedWithCompatibleDataType: {
        name: 'joinAllowedWithCompatibleDataType',
        description: 'Flag for Enable Join Creation Between Compatible Column Data Types',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    supportDeletionWithDependents: {
        name: 'supportDeletionWithDependents',
        description: 'Flag to enable deletion of an object having dependents.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    showGenericJoinCreationModal: {
        name: 'showGenericJoinCreationModal',
        description: 'Flag to enable new generic join modal for blink.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableDeleteDependentJoin: {
        name: 'enableDeleteDependentJoin',
        description: 'Flag to indicate whether to delete a join if dependent exists.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableGlobalJoinDirectionReversal: {
        name: 'enableGlobalJoinDirectionReversal',
        description: 'This flag enables reversal of table level join direction',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    columnSecurityRuleEnabled: {
        name: 'columnSecurityRuleEnabled',
        description: 'This flag enables column security rule functionality',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    csrABACEnabled: {
        name: 'csrABACEnabled',
        description: 'This flag enables column security ABAC functionality',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableV2ModelShare: {
        name: 'enableV2ModelShare',
        description: 'This flag enables new UI for Model sharing functionality',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    syncWithSource: {
        name: 'syncWithSource',
        description: 'This flag enables table column properties in sync with derived columns for Model and Views',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    columnGeoRestrictions: {
        name: 'columnGeoRestrictions',
        description: 'Flag to restrict editing of geo-config for types other than int int double and varchar.',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    highlightProFeatures: {
        name: 'highlightProFeatures',
        description: 'Flag to show upgrade-only options',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    redesignedHomepage: {
        name: 'redesignedHomepage',
        description: 'Flag to show redesigned homepage',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    embracev2Experience: {
        name: 'embracev2Experience',
        description: 'Flag to enable/disable Embrace V2 Experience',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    newConnectionsExperience: {
        name: 'newConnectionsExperience',
        description: 'Flag to enable/disable new connections workflow',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableDataWorkspaceTableV2: {
        name: 'enableDataWorkspaceTableV2',
        description: 'Flag to enable/disable new dataworkspace table workflow',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    connectorsCategorizationEnabled: {
        name: 'connectorsCategorizationEnabled',
        description: 'Flag to enable/disable connectors categorization',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    sqlEditorAutoCompleteEnabled: {
        name: 'sqlEditorAutoCompleteEnabled',
        description: 'Flag to enable/disable auto complete feature in the SQL Editor',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isOauthAutoRedirectEnabled: {
        name: 'isOauthAutoRedirectEnabled',
        description: 'Flag to enable/disable automatic redirection on oauth failure from liveboards page',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableConnectionSharingV2Apis: {
        name: 'enableConnectionSharingV2Apis',
        description: 'Flag to enable/disable v2 apis for connection sharing',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    singleWindowOAuthEnabled: {
        name: 'singleWindowOAuthEnabled',
        description: 'Flag to enable/disable OAuth redirection in same window instead of new tab',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    connectionPayloadRestructuringEnabled: {
        name: 'connectionPayloadRestructuringEnabled',
        description: 'Flag to enable/disable sending all metadata to the APIs',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    remappingV2Experience: {
        name: 'remappingV2Experience',
        description: 'Flag to enable/disable enabling the connections remapping experience',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isEmbraceEnabled: {
        name: 'isEmbraceEnabled',
        description: 'Flag to enable/disable Embrace',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    csvUploadV2Enabled: {
        name: 'csvUploadV2Enabled',
        description: 'Flag to enable/disable new experience for Csv Upload',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    embraceCsvUploadMode: {
        name: 'embraceCsvUploadMode',
        description: 'Flag to enable/disable Embrace Csv Upload',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    falconCsvUploadMode: {
        name: 'embraceCsvUploadMode',
        description: 'Flag to enable/disable Embrace Csv Upload',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    searchCacheEnabledDatasources: {
        name: 'searchCacheEnabledDatasources',
        description: 'Flag to control the datasources enabled for Search Cache',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    useColumnValueCasing: {
        name: 'useColumnValueCasing',
        description: 'Flag to enable/disable value casing column in worksheet',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    userSource: {
        name: 'userSource',
        description: 'Flag to source of user source in user properties',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    enableClientSideTracing: {
        name: 'enableClientSideTracing',
        description: 'Flag to control client side tracing',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableTableExport: {
        name: 'enableTableExport',
        description: 'Flag to enable/disable export and import of tables inside the data tab',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    enableSpotAppExport: {
        name: 'enableSpotAppExport',
        description: 'Flag to enable/disable export of spotapp in the data tab',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    pinboardCreationPrivilegeEnabled: {
        name: 'pinboardCreationPrivilegeEnabled',
        description: 'Flag to enable/disable pinboard creation privilege for embedded customers',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    intercomEnabled: {
        name: 'intercomEnabled',
        description: 'Flag to enable/disable Intercom integration',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isLiveboardEnabled: {
        name: 'isLiveboardEnabled',
        description: 'Flag to set liveboard enabled true',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    aiAnswerGenerationEnabled: {
        name: 'aiAnswerGenerationEnabled',
        description: 'Flag to enable ai answer generation for eureka frontend',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSageCoachMFE: {
        name: 'enableSageCoachMFE',
        description: 'Flag to enable sage coach MFE',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableKaiosAgent: {
        name: 'enableKaiosAgent',
        description: 'Enable Kaios Agent',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSpotterVizInViewModeEnabled: {
        name: 'isSpotterVizInViewModeEnabled',
        description: 'Enable SpotterViz in view mode',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSpotterVizZeroState: {
        name: 'enableSpotterVizZeroState',
        description: 'Enable SpotterViz Zero State',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableFileUpload: {
        name: 'enableFileUpload',
        description: 'Enable SpotterViz file upload button',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    themeBuilderAiMode: {
        name: 'themeBuilderAiMode',
        description: 'theme Builder Ai Mode',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    spotterCodeEnabled: {
        name: 'spotterCodeEnabled',
        description: 'spotterCode Enabled',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    webhooksV2Enabled: {
        name: 'webhooksV2Enabled',
        description: 'Enable Webhooks V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    nlsFeedbackCRUDUiEnabled: {
        name: 'nlsFeedbackCRUDUiEnabled',
        description: 'Flag to enable CRUD UI for NLS feedback',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSageWarningMessages: {
        name: 'enableSageWarningMessages',
        description: 'Flag to enable warning messages on sage',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    captainEnabled: {
        name: 'captainEnabled',
        description: 'Flag to enable captain page',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    showDeleteCaptainWorkspace: {
        name: 'showDeleteCaptainWorkspace',
        description: 'Flag to show delete captain workspace',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    optimizelyEnabled: {
        name: 'optimizelyEnabled',
        description: 'Flag to enable/disable Optimizely integration',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    optimizelyDataFileFetchInterval: {
        name: 'optimizelyDataFileFetchInterval',
        description: 'Flag to change datafile fetch interval',
        type: 'number',
        isListed: false,
        defaultValue: 600,
    },
    tableJoinV2Enabled: {
        name: 'tableJoinV2Enabled',
        description: 'Flag to enable/disable table join v2 in UI',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableAAQ: {
        name: 'enableAAQ',
        description: 'Flag to enable/disable analyst authored queries',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableMonitorV2: {
        name: 'enableMonitorV2',
        description: 'Flag to enable/disable analyst monitor v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableExplainChange: {
        name: 'enableExplainChange',
        description: 'Flag to enable/disable explain change on kpi charts',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableContexualAlertCreation: {
        name: 'enableContexualAlertCreation',
        description: 'Flag to enable/disable contexual alert creation.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMonitorV2Tab: {
        name: 'enableMonitorV2Tab',
        description: 'Flag to enable/disable monitor V2 tab',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableThresholdBasedAlerts: {
        name: 'enableThresholdBasedAlerts',
        description: 'Flag to enable/disable threshold alerts in monitor',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMonitorAlertNotificationChannel: {
        name: 'enableMonitorAlertNotificationChannel',
        description: 'Flag to enable/disable Notification section in monitor alerts',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableWebhookLCM: {
        name: 'enableWebhookLCM',
        description: 'Flag to enable/disable Webhook LCM in develop tab',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableContextualChangeAnalysis: {
        name: 'enableContextualChangeAnalysis',
        description: 'Flag to enable/disable contextual change analysis',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableChangeAnalysisByMeasure: {
        name: 'enableChangeAnalysisByMeasure',
        description: 'Flag to enable/disable change analysis by measure',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSpotIQV2: {
        name: 'enableSpotIQV2',
        description: 'Flag to enable/disable SpotIQV2',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSpotIQForecast: {
        name: 'enableSpotIQForecast',
        description: 'Flag to enable/disable SpotIQ forecast',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableWhatIfAnalysis: {
        name: 'enableWhatIfAnalysis',
        description: 'Flag to enable/disable what if analysis for SpotIQ',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableKeyDriversAnalysis: {
        name: 'enableKeyDriversAnalysis',
        description: 'Flag to enable/disable key drivers analysis for SpotIQ',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableThirdPartyAnalysis: {
        name: 'enableThirdPartyAnalysis',
        description: 'Flag to enable/disable Third Party Analysis ML platforms for SpotIQ',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableCCASummaryTab: {
        name: 'enableCCASummaryTab',
        description: 'Flag to enable/disable summary tab for cca',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableAnalyzeButton: {
        name: 'enableAnalyzeButton',
        description: 'Flag to enable/disable analyze button for cca',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableAdditionalInsights: {
        name: 'enableAdditionalInsights',
        description: 'Flag to enable/disable additional insights for cca',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableCCAConfiguredColumns: {
        name: 'enableCCAConfiguredColumns',
        description: 'Flag to enable/disable Configured columns for contextual change analysis',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    answerV2InPinboardV1: {
        name: 'answerV2InPinboardV1',
        description: 'Enable Answer V2 in Pinboard V1',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    isPinboardV2TabsEnabled: {
        name: 'isPinboardV2TabsEnabled',
        description: 'Enable Tabs in Pinboard V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAutoWorksheetEnabled: {
        name: 'autoWorksheetEnabled',
        description: 'Enable auto worksheet for setup flow',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    importV2Experience: {
        name: 'importV2Experience',
        description: 'If true, import-v2 would be embedded in parent blink app',
        type: 'boolean',
        isListed: false,
        defaultValue: true,
    },
    onlySingleUploadAllowed: {
        name: 'onlySingleUploadAllowed',
        description: 'Flag to set if only single upload is allowed',
        type: 'boolean',
        isListed: true,
        defaultValue: null,
    },
    enableSetupV2: {
        name: 'enableSetupV2',
        description: 'Flag to enable/disable Setup V2 for analyst onboarding',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hasSeenWorksheetTour: {
        name: 'hasSeenWorksheetTour',
        description: 'Flag to know if the user has seen worksheet tour or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    pinboardFollowEnabled: {
        name: 'pinboardFollowEnabled',
        description: 'Flag to know if pinboard follow is enabled or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    vizRenderingQueueTimeoutMS: {
        name: 'vizRenderingQueueTimeoutMS',
        description: 'flag to override default viz rendering queue timeout in ms',
        type: 'number',
        isListed: false,
        defaultValue: undefined,
    },
    enableHighchartsWarmup: {
        name: 'enableHighchartsWarmup',
        description: 'Warm up Highcharts globals after the chart-viz chunk loads ' +
            'by rendering + destroying a hidden 1x1 throwaway chart. ' +
            'Amortizes first-tile cold-start.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    fetchPivotSummaryFromBackend: {
        name: 'fetchPivotSummaryFromBackend',
        description: 'Flag to know if fetch Pivot Summary From Backend using multiple queries',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    hasSeenPinsFlow: {
        name: 'hasSeenPinsFlow',
        description: 'Flag to know if the user has first time user acivity pins flow',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hasSeenPinsSpotlight: {
        name: 'hasSeenPinsSpotlight',
        description: 'Flag to know if the user has first time user acivity pins flow',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAnswerUndoStackEnabled: {
        name: 'isAnswerUndoStackEnabled',
        description: 'Flag to enable/disable undo button on answer page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAutoAnswerEnabled: {
        name: 'autoAnswerEnabled',
        description: 'Enable auto answer for setup flow',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isColumnSummariesEnabledByDefault: {
        name: 'isColumnSummariesEnabledByDefault',
        description: 'If true, enable column summaries by default',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableKPIChart: {
        name: 'enableKPIChart',
        description: 'If true, enable kpi chart by default',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableKPIChartOnAttributes: {
        name: 'enableKPIChartOnAttributes',
        description: 'If true, enable kpi chart on attributes by default',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    forcedExperimentKey: {
        name: 'forcedExperimentKey',
        description: 'name of the forced experiment',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    forcedVariationKey: {
        name: 'forcedVariationKey',
        description: 'name of the forced variation',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    firstPinExperience: {
        name: 'firstPinExperience',
        description: 'returns true if the firstPinExperience is enabled',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    firstPinExperienceSpotlightTimeout: {
        name: 'firstPinExperienceSpotlightTimeout',
        description: 'returns default value of spotlight timeout.',
        type: 'number',
        isListed: true,
        defaultValue: 2000,
    },
    firstPinExperienceSageTokens: {
        name: 'firstPinExperienceSageTokens',
        description: 'returns default value of number of sage tokens.',
        type: 'number',
        isListed: true,
        defaultValue: 2,
    },
    searchPageExperimentAssets: {
        name: 'search_page_experiment_assets',
        description: 'returns default value of search_page_experiment_assets.',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    expiryBannerSearchPageExperimentAssets: {
        name: 'expiry_banner',
        description: 'returns default value of expiry_banner',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableWelcomeOnboardingPageV2: {
        name: 'welcome_page_v2',
        description: 'returns default value of welcome_page_v2',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableSharePromotionExp: {
        name: 'shareConfig',
        description: 'Optimizely flag that controls share promotion ui',
        type: 'string',
        isListed: true,
        defaultValue: 'default',
    },
    csvAutoAnswerRedirect: {
        name: 'csv_auto_answer_redirect',
        description: 'returns default value of csv_auto_answer_redirect.',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    errorCode: {
        name: 'errorCode',
        description: 'Flag to display error message based on error code',
        type: 'number',
        isListed: false,
        defaultValue: undefined,
    },
    hasSeenAutoAnswerTour: {
        name: 'hasSeenAutoAnswerTour',
        description: 'Flag to know if the user has seen auto answer tour or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCustomEmbedUrlEnabled: {
        name: 'isCustomEmbedUrlEnabled',
        description: 'Enable custom embed url check box',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCustomTileEnabled: {
        name: 'isCustomTileEnabled',
        description: 'Enable free flowing resize on ponboard v2',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSpotApps: {
        name: 'enableSpotApps',
        description: 'Enable Spot App flag for Team Edition Data Model V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableDataAppV2: {
        name: 'enableDataAppV2',
        description: 'Enable Team Edition flag for Data Model V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableDataPipeline: {
        name: 'enableDataPipeline',
        description: 'Enable Data Pipline flag for Team Edition in Data Model V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableIntegration: {
        name: 'enableIntegration',
        description: 'Enable Integration flag for Team Edition in Data Model V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSearchCache: {
        name: 'enableSearchCache',
        description: 'Enable Search Cache for external views in Data model',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    searchDataInNav: {
        name: 'searchDataInNav',
        description: 'Flag to enable Search Data button in navbar and hides sage/eureka toggle',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSQLEditor: {
        name: 'enableSQLEditor',
        description: 'Enable sqlEditor flag for Team Edition in Data Model V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableOIDCAutoRedirect: {
        name: 'disableOIDCAutoRedirect',
        description: 'Override the system configuration to auto redirect to OIDC login',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    ssoOnActivationEnabled: {
        name: 'ssoOnActivationEnabled',
        description: 'Override the system configuration to show SSO options on the account activation screen',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    eurekaSearchBarInNav: {
        name: 'eurekaSearchBarInNav',
        description: 'Enable eureka search bar in nav',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    purchaseOption: {
        name: 'purchaseOption',
        description: 'Flag to determine user purchase option',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    subscriptionType: {
        name: 'subscriptionType',
        description: 'Flag to determine user subscription type',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    inviteModalType: {
        name: 'inviteModalType',
        description: 'Flag to determine invite modal type',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    userType: {
        name: 'userType',
        description: 'Flag to determine  user type',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    enableTeams: {
        name: 'enableTeams',
        description: 'Flag to determine whether teams is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    planPageURL: {
        name: 'planPageURL',
        description: 'Flag to set plan page URL',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    enableComs: {
        name: 'enableComs',
        description: 'Flag to determin whether coms is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableInAppNotification: {
        name: 'enableInAppNotification',
        description: 'Flag to determine whether in app notification is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableSlackBot: {
        name: 'enableSlackBot',
        description: 'Flag to determine whether slack bot is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableInAppNotificationsExperiment: {
        name: 'in_app_notifications',
        description: 'Optimizely flag that controls in app notifications',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    isMsTeamsBotEnabled: {
        name: 'isMsTeamsBotEnabled',
        description: 'Flag to determine whether MS Teams bot is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isMsTeamsNotificationPreferenceEnabled: {
        name: 'isMsTeamsNotificationPreferenceEnabled',
        description: 'Flag to determine whether Ms teams notification preference is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableDataUsageTab: {
        name: 'enableDataUsage',
        description: 'Flag to determine whether data usage is enabled or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    softlimitEnabledForTeamsEdition: {
        name: 'isSoftLimitEnabledForTeamEdition',
        description: 'Flag to determine whether soft limit for users in TE orgs is enabled or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    optimizeAddUserFlowEnabled: {
        name: 'optimizeadduserflowenabled',
        description: 'Flag to determine whether optimized add user flow is enabled in FT / TE or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableOrgsOnFTPhase2: {
        name: 'enableOrgsOnFTPhase2',
        description: 'Flag for orgs phase 2 in ft/te',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    userLimitAlertEnabledForTE: {
        name: 'userLimitAlertEnabledForTE',
        description: 'Flag for orgs phase 2 in ft/te',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isSaaSCluster: {
        name: 'isSaaSCluster',
        description: 'Blink flag for Saas cluster',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMultipleDemoDatasets: {
        name: 'enableMultipleDemoDatasets',
        description: 'Flag to determine if multiple demo datasets is enabled or not',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableDbtInt: {
        name: 'enableDbtInt',
        description: 'Enable Dbt integration flag for Team Edition Data Model V2 utilities',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    eagerDataLoadingForPinboardViz: {
        name: 'eagerDataLoadingForPinboardViz',
        description: 'Load data and metadata for context book together',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    legalDisclaimerText: {
        name: 'legalDisclaimerText',
        description: 'Showing a legal disclaimer in downloaded PDF footer',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    subscriptionStatus: {
        name: 'subscriptionStatus',
        description: 'Flag to determine user subscription status',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    isRAnalysisEnabled: {
        name: 'isRAnalysisEnabled',
        description: 'If true, answer-v2 would enable the R Analysis functionality',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableShareV2: {
        name: 'enableShareV2',
        description: 'enable share v2',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableDiscountForTrialUser: {
        name: 'enableDiscountForTrialUser',
        description: 'enable discount for trial user',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    learningModuleVideosList: {
        name: 'videos_list',
        description: 'enable discount for trial user',
        type: 'json',
        isListed: true,
        defaultValue: null,
    },
    enableOrgsOnFT: {
        name: 'enableOrgsOnFT',
        description: 'enable Orgs on FT/TE',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    modularHomeExperience: {
        name: 'modularHomeExperience',
        description: 'enable modularHomeExperience',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isLibraryFilteringImprovementsEnabled: {
        name: 'isLibraryFilteringImprovementsEnabled',
        description: 'Enable filterning improvement on homepage object table',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isNewNavigationHomepageExperienceOnByDefault: {
        name: 'isNewNavigationHomepageExperienceOnByDefault',
        description: 'enable isNewNavigationHomepageExperienceOnByDefault',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableInviteInShareV2: {
        name: 'enableInviteInShareV2',
        description: 'enable inviting new users in share v2',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    isSortByLastModifiedEnabled: {
        name: 'isSortByLastModifiedEnabled',
        description: 'Enable sort by last modified on homepage object table',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    inviteUsersV2: {
        name: 'invite_users_v2',
        description: 'returns the default value of invite users v2',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    inviteTeammatesEntryPoints: {
        name: 'invite_teammates_entry_points',
        description: 'returns the default value of invite_teammates_entry_points',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    setupHubInviteTeammatesEntryPoint: {
        name: 'setup_hub',
        description: 'returns the default value  ',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    connCredInviteTeammatesEntryPoint: {
        name: 'conn_cred_page',
        description: 'returns the default value  ',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableSpotAppsAdminForE2E: {
        name: 'enableSpotAppsAdminForE2E',
        description: 'Enable SpotApps admin tab for E2E',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hasUserUpdatedDisplayName: {
        name: 'hasUserUpdatedDisplayName',
        description: 'Flag which helps define if user has updated display name or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isUpdateDisplayNameEnabled: {
        name: 'isUpdateDisplayNameEnabled',
        description: 'Flag to control update display name feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isHtmlRenderingDisabled: {
        name: 'isHtmlRenderingDisabled',
        description: 'Flag to control HTML rendering',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isHighchartCustomisationEnabled: {
        name: 'isHighchartCustomisationEnabled',
        description: 'Enable Highchart customisation for answers',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isPieChartEnhancementsEnabled: {
        name: 'isPieChartEnhancementsEnabled',
        description: 'Enable Pie chart enhancements',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    orgId: {
        name: 'orgId',
        description: 'Flag to store current orgId state',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    collapseSearchBarInitially: {
        name: 'collapseSearchBarInitially',
        description: 'Collapse search bar to single line',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    dataPanelCustomGroupsAccordionInitialState: {
        name: 'dataPanelCustomGroupsAccordionInitialState',
        description: 'Defines the initial state of column custom group accordions',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    enableDataPanelV2: {
        name: 'enableDataPanelV2',
        description: 'Flag to enable Data Panel V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCustomColumnGroups: {
        name: 'enableCustomColumnGroups',
        description: 'Flag to enable custom column groups in Data Panel V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideAtoZViewInDataPanelV2: {
        name: 'hideAtoZViewInDataPanelV2',
        description: 'Flag to hide A-Z view in data panel v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSpotterAgentExperience: {
        name: 'enableSpotterAgentExperience',
        description: 'Flag to enable Spotter Agent Experience in a cluster',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCopyFormulaEnabled: {
        name: 'isCopyFormulaEnabled',
        description: 'Flag to enable/disable make a copy button for formula',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    statusPageEnabled: {
        name: 'statusPageEnabled',
        description: 'Flag to enable/disable Status Page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    useVirtualizationInDataPanelV2: {
        name: 'useVirtualizationInDataPanelV2',
        description: 'Flag to force virtualization state in Data Panel v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    loginEnabledForExpiredUser: {
        name: 'allowLogin',
        description: 'Flag to store current orgId state',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    userState: {
        name: 'userState',
        description: 'Flag to override logged in user status',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    isNoteTilesEnabled: {
        name: 'isNoteTilesEnabled',
        description: 'Enable Note Tiles in Pinboard V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isMandatoryFilterEnabled: {
        name: 'isMandatoryFilterEnabled',
        description: 'Enable Mandatory Filter in Pinboard V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCompactLayoutEnabled: {
        name: 'isCompactLayoutEnabled',
        description: 'Enable Compact Layout',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isMobileResponsiveLiveboardEnabled: {
        name: 'isMobileResponsiveLiveboardEnabled',
        description: 'Enable Mobile Responsiveness for Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCrossFiltersEnabled: {
        name: 'isCrossFiltersEnabled',
        description: 'Enable Cross Filters in Liveboards',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isHiddenColWSAccessible: {
        name: 'isHiddenColWSAccessible',
        description: 'Make worksheet containing hidden column accessible in liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCustomSortingEnabled: {
        name: 'isCustomSortingEnabled',
        description: 'Enable Custom sorting on Answers',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isDatePickerEnabled: {
        name: 'isDatePickerEnabled',
        description: 'Enable DatePicker',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isDateFilterChipMatchingSearchToken: {
        name: 'isDateFilterChipMatchingSearchToken',
        description: 'Enable Date Filter Chip Matching Search Token',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isThisPeriodInDateFiltersEnabled: {
        name: 'isThisPeriodInDateFiltersEnabled',
        description: 'Enable This Period checkbox in rolling date filters',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isScopedLiveboardFilteringEnabled: {
        name: 'isScopedLiveboardFilteringEnabled',
        description: 'Enable scoped liveboard filtering',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hidePreviewForRollingFiltersWithCC: {
        name: 'hidePreviewForRollingFiltersWithCC',
        description: 'Disable date filter previews for custom calendar',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isNewScheduleModalEnabled: {
        name: 'isNewScheduleModalEnabled',
        description: 'Enable new schedule modal experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isEveryNMinutesFrequencyDisabled: {
        name: 'isEveryNMinutesFrequencyDisabled',
        description: 'Disable every N minutes frequency option for schedules',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardSchedulesUtilityDisabled: {
        name: 'isLiveboardSchedulesUtilityDisabled',
        description: 'Disable the Liveboard schedules entry in Data Utilities',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isReorderedEllipsisMenuEnabled: {
        name: 'isReorderedEllipsisMenuEnabled',
        description: 'Enable reordered ellipsis menu experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAddAnswerInLiveboardEnabled: {
        name: 'isAddAnswerInLiveboardEnabled',
        description: 'Enable adding new answer from the liveboard edit mode',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isFilterSVSEnabled: {
        name: 'isFilterSVSEnabled',
        description: 'Enable Single Value Selection in Filters',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isFilterRenamingEnabled: {
        name: 'isFilterRenamingEnabled',
        description: 'Enable Renaming in Filters',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isPersonalisedViewsEnabled: {
        name: 'isPersonalisedViewsEnabled',
        description: 'Enable Personalised Views in Liveboards',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isParameterChipReorderingEnabled: {
        name: 'isParameterChipReorderingEnabled',
        description: 'Enable parameter reordering',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isContextMenuEnabledOnLeftClick: {
        name: 'isContextMenuEnabledOnLeftClick',
        description: 'Enable Context Menu on left click',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isTableWidthScalingEnabled: {
        name: 'isTableWidthScalingEnabled',
        description: 'Enable table width scaling based on screen size',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardHeaderSticky: {
        name: 'isLiveboardHeaderSticky',
        description: 'Enable Liveboard sticky header',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardHeaderV2Enabled: {
        name: 'isLiveboardHeaderV2Enabled',
        description: 'Enable Liveboard compact header',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideIrrelevantFiltersAtTabLevel: {
        name: 'hideIrrelevantFiltersAtTabLevel',
        description: 'Enable Hide irrelevant filters at tab level in Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardStylingEnabled: {
        name: 'isLiveboardStylingEnabled',
        description: 'Enable Liveboard styling',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardMasterpiecesEnabled: {
        name: 'isLiveboardMasterpiecesEnabled',
        description: 'Enable Liveboard styling and grouping',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAnswerEditInLiveboardEditModeEnabled: {
        name: 'isAnswerEditInLiveboardEditModeEnabled',
        description: 'Enable answer edit in Liveboard edit mode',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isInsightTileEnabled: {
        name: 'isInsightTileEnabled',
        description: 'Enable Insight tile in Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isInsightTileBackgroundEnabled: {
        name: 'isInsightTileBackgroundEnabled',
        description: 'Enable Insight tile background changes in Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSpotterXEnabled: {
        name: 'isSpotterXEnabled',
        description: 'Enable Spotter-X',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showSpotterXOptionOnAdminPanel: {
        name: 'showSpotterXOptionOnAdminPanel',
        description: 'Show the SPOTTER_X option in the Spotter experience dropdown on ' +
            'the admin panel',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardPNGExportV2Enabled: {
        name: 'isLiveboardPNGExportV2Enabled',
        description: 'Enable Liveboard PNG Export V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isWYSIWYGLiveboardPDFEnabled: {
        name: 'isWYSIWYGLiveboardPDFEnabled',
        description: 'Enable WYSIWYG PDF flow for Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableColumnDeletionWithDependents: {
        name: 'enableColumnDeletionWithDependents',
        description: 'Enable column deletion with dependents',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isComsForLiveboardSchedulesEnabled: {
        name: 'isComsForLiveboardSchedulesEnabled',
        description: 'Enable COMS for Liveboard Schedules',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isPNGInScheduledEmailsEnabled: {
        name: 'isPNGInScheduledEmailsEnabled',
        description: 'Enable Liveboard PNG embed in emails',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    embedPngScale: {
        name: 'embedPngScale',
        description: 'Override device scale percentage for PNG embed in scheduled emails',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    isAnswerExportV2Enabled: {
        name: 'isAnswerExportV2Enabled',
        description: 'Flag to enable Answer Export API V2, which supports exporting answers ' +
            'pinned inside liveboards using the pinboard context.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isGranularXLSXCSVSchedulesEnabled: {
        name: 'isGranularXLSXCSVSchedulesEnabled',
        description: 'Enable granular XLSX/CSV schedules',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCombinedXLSXReportEnabled: {
        name: 'isCombinedXLSXReportEnabled',
        description: 'Enable combined XLSX report',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isSendNowLiveboardSchedulingEnabled: {
        name: 'isSendNowLiveboardSchedulingEnabled',
        description: 'Enable Send Now for Liveboard Schedules',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLinkParametersEnabled: {
        name: 'isLinkParametersEnabled',
        description: 'Enable Link Parameters in Liveboard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    arePdfCoverFilterPageCheckboxesEnabled: {
        name: 'arePdfCoverFilterPageCheckboxesEnabled',
        description: 'Enable checkboxs to add/remove cover and filter pages in pdf options.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    arePdfCoverFilterPageDefaultsChecked: {
        name: 'arePdfCoverFilterPageDefaultsChecked',
        description: ' Setting the default values for the checkboxes cover and filter pages in pdf options.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isEmbedInNoteTilesEnabled: {
        name: 'isEmbedInNoteTilesEnabled',
        description: 'Enable embedding in Note Tile in a LiveBoard',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableNoteTileTextSpacingUpdates: {
        name: 'enableNoteTileTextSpacingUpdates',
        description: 'Enable text spacing updates in Note Tile',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAttributeNfEnabled: {
        name: 'isAttributeNfEnabled',
        description: 'Flag to enable/disable number formatting on attributes',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isChartSkillsEnabled: {
        name: 'isChartSkillsEnabled',
        description: 'Flag to enable/disable chart skills',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    enableMinimumBarHeight: {
        name: 'enableMinimumBarHeight',
        description: 'Flag to control min bar height in charts to handle the 0 or relatively small value presentation',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    handleMissingValues: {
        name: 'handleMissingValues',
        description: 'Flag to control the visibility of the dropdown based handling of missing/null values. It appears in the "Edit chart configuration" tab.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableGridlines: {
        name: 'enableGridlines',
        description: 'Flag to show gridlines default based on chart axis configuration',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableLiveboardQueryStatus: {
        name: 'enableLiveboardQueryStatus',
        description: 'Flag to display Liveboard Query Status to the users',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showChartApplyandResetButtons: {
        name: 'showChartApplyandResetButtons',
        description: 'Flag to show apply and reset button in chart configurator',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableShareInInvite: {
        name: 'enableShareInInvite',
        description: 'Flag to enable share in invite workflow',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    applyContrastForDataLabels: {
        name: 'applyContrastForDataLabels',
        description: 'Flag to apply contrastForDataLabels in chart configurator',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAttributesInPivotDataArea: {
        name: 'enableAttributesInPivotDataArea',
        description: 'Flag to enable attributes in pivot table data area',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isRolesEnabled: {
        name: 'isRolesEnabled',
        description: 'Flag to know if role is enabled or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableRbacForEmbrace: {
        name: 'enableRbacForEmbrace',
        description: 'Flag to know if RBAC for Embrace is enabled or not',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    zoomedRenderWidthForExport: {
        name: 'zoomedRenderWidthForExport',
        description: 'Flag to determine the width on which print page (/print) is rendered for export.',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    zoomedRenderWidthForExportV2: {
        name: 'zoomedRenderWidthForExportV2',
        description: 'Render width for the standard zoom option in WYSIWYG PDF export V2.',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    maxVizInTabForExport: {
        name: 'maxVizInTabForExport',
        description: 'Flag to determine the maximum number of Vizs to be present in a single Tab for PDF export.',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardTabExportEnabled: {
        name: 'isLiveboardTabExportEnabled',
        description: 'Flag to determine if Tab wise Liveboard PDF download is enabled.',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableStandardRegion: {
        name: 'enableStandardRegion',
        description: 'Enables ability to choose geo map based chart for columns without geoconfig and uses geocoding service',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSeedQuestions: {
        name: 'enableSeedQuestions',
        description: 'Enables Seed Questions',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSystemFragments: {
        name: 'enableSystemFragments',
        description: 'Enables System Generated Fragments',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableColdStart: {
        name: 'enableColdStart',
        description: 'Enables Cold Start Run',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableQueryVisualizerV2: {
        name: 'enableQueryVisualizerV2',
        description: 'Enables Query Visualizer V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableConvAssistByDefault: {
        name: 'enableConvAssistByDefault',
        description: 'Enables Conv Assist by default',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableConvAssist: {
        name: 'enableConvAssist',
        description: 'Enables Conv Assist',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableConvAssistFromNls: {
        name: 'enableConvAssistFromNls',
        description: 'Enables Conv Assist from NLS',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableShowQueryByDefaultForConvAssist: {
        name: 'enableShowQueryByDefaultForConvAssist',
        description: 'Flag to set conv assist show query toggle default value',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    allowRegeneratingSeedQuestions: {
        name: 'allowRegeneratingSeedQuestions',
        description: 'Allow Regenerating new Seed Questions',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableHeadlinePinning: {
        name: 'enableHeadlinePinning',
        description: 'If true, pin button will be shown in the headline',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    overrideOrgId: {
        name: 'orgId',
        description: 'Flag to store current context orgId',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    allowCreatingWSToUploadedTableJoins: {
        name: 'allowCreatingWSToUploadedTableJoins',
        description: 'Flag for allowing creating joins bw worksheet and user uploaded tables',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    enableCustomCharts: {
        name: 'enableCustomCharts',
        description: 'Allow using Custom BYOC charts functionality.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isTooltipCustomizationEnabled: {
        name: 'isTooltipCustomizationEnabled',
        description: 'Enable tooltip customization for charts.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    reactShellExperience: {
        name: 'reactShellExperience',
        description: 'Indicates react shell experience.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    skipClientStateSchemaCheck: {
        name: 'skipClientStateSchemaCheck',
        description: 'Skip client state schema check',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isRenamingColumnsEnabled: {
        name: 'isRenamingColumnsEnabled',
        description: 'Enables renaming column names by users',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    mergePivotExportedRowsAndColumns: {
        name: 'mergePivotExportedRowsAndColumns',
        description: 'States of pivot table export wrt merging of rows/column header values which are expanded',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    canCreateOrEditConnections: {
        name: 'canCreateOrEditConnections',
        description: 'Controls the ability to create or edit Embrace connections',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    canManageCustomCalendars: {
        name: 'canManageCustomCalendars',
        description: 'Controls the ability to create/view/edit/delete custom calendars',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isHiddenTableColumnsEnabled: {
        name: 'isHiddenTableColumnsEnabled',
        description: 'Flag to enable hiding of table viz columns',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isExploreFiltersExpandable: {
        name: 'isExploreFiltersExpandable',
        description: 'Flag to enable expandable filters in explore modal',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isEnhancedCfEnabled: {
        name: 'isEnhancedCfEnabled',
        description: 'Flag to enable enhanced conditional formatting.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isGradientColoringEnabled: {
        name: 'isGradientColoringEnabled',
        description: 'Flag to enable gradient based coloring.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    gradientBufferEnabled: {
        name: 'gradientBufferEnabled',
        description: 'Flag to enable min and max buffer in gradient of heatmap chart.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isChartSettingsV2Enabled: {
        name: 'isChartSettingsV2Enabled',
        description: 'Flag to enable chart settings v2 experience.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    customChartRowsLimit: {
        name: 'customChartRowsLimit',
        description: 'Max data rows fetched/rendered for custom charts (URL override).',
        type: 'number',
        isListed: true,
        defaultValue: undefined,
    },
    isGitIntegrationEnabled: {
        name: 'isGitIntegrationEnabled',
        description: 'Flag to enable git integration.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isGitIntegrationUIEnabled: {
        name: 'isGitIntegrationUIEnabled',
        description: 'Flag to enable git integration user interface.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isVersionHistoryEnabled: {
        name: 'isVersionHistoryEnabled',
        description: 'Flag to enable show version history option in liveboard/answers',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    canManageVersionControl: {
        name: 'canManageVersionControl',
        description: 'Flag to enable show can manage version control option in privilegess',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    usersGroupsV2Experience: {
        name: 'usersGroupsV2Experience',
        description: 'Flag to enable users and groups v2 pages',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    authV2Experience: {
        name: 'authV2Experience',
        description: 'enable authV2Experience',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    orgPerUrlEnabled: {
        name: 'orgPerUrlEnabled',
        description: 'enable orgPerUrl',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    customNumberFormatPatternForGeoChart: {
        name: 'customNumberFormatPatternForGeoChart',
        description: 'custom number format pattern to override all format patterns applied only for geo charts',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardHighlightsEnabled: {
        name: 'isLiveboardHighlightsEnabled',
        description: 'Enable Liveboard Highlights',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardHighlightsToastEnabled: {
        name: 'isLiveboardHighlightsToastEnabled',
        description: 'Enable Liveboard Highlights toast on every load',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    liveboardHighlightsQueryTimeout: {
        name: 'liveboardHighlightsQueryTimeout',
        description: 'Liveboard Highlights polling timeout',
        type: 'number',
        isListed: true,
        defaultValue: 120000,
    },
    isLiveboardNewBreakPointsEnabled: {
        name: 'isLiveboardNewBreakPointsEnabled',
        description: 'Enable Liveboard Custom breakpoints',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isScheduleOnHomeEnabled: {
        name: 'isScheduleOnHomeEnabled',
        description: 'Enable Liveboard Schedule on home page',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableIterativeCCA: {
        name: 'enableIterativeCCA',
        description: 'Flag to enable iterative contextual change analysis',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    overrideConsoleLogs: {
        name: 'overrideConsoleLogs',
        description: 'Flag to override log methods and mute them',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    showServiceAccountOnly: {
        name: 'showServiceAccountOnly',
        description: 'Flag to only service account connections creation in captain',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    isDynamicColumnWidthForPivotEnabled: {
        name: 'isDynamicColumnWidthForPivotEnabled',
        description: 'Flag to control the dynamic column width for Pivot table.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isSoftwareCluster: {
        name: 'isSoftwareCluster',
        description: 'Blink flag for Software cluster',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isAllowPVShareEnabled: {
        name: 'isAllowPVShareEnabled',
        description: 'Enable/disable access to make a personalised view public',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    shouldShowFragmentConfirmationModal: {
        name: 'shouldShowFragmentConfirmationModal',
        description: 'Flag to enable/disable notification modal for dependent fragments.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    shouldShowOptimizeSageBtn: {
        name: 'shouldShowOptimizeSageBtn',
        description: 'Flag to enable/disable optimize sage button.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAnomalyBasedAlert: {
        name: 'enableAnomalyBasedAlert',
        description: 'Flag to enable/disable anomaly based alert in alert modal.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isMeasureNamesEnabled: {
        name: 'isMeasureNamesEnabled',
        description: 'Flag to enable/disable measure names & values for charts.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAlertAcrossAttributes: {
        name: 'enableAlertAcrossAttributes',
        description: 'Flag to enable/disable alert across attributes.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCenterSingleValueKPI: {
        name: 'enableCenterSingleValueKPI',
        description: 'Flag to enable/disable centering of single-value KPIs (non time-series KPIs)',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    showFullKPIValueOnTooltip: {
        name: 'showFullKPIValueOnTooltip',
        description: 'Flag to enable displaying the full KPI value in the tooltip when hovering over the KPI hero',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableKPIChartEnhancements: {
        name: 'enableKPIChartEnhancements',
        description: 'Flag to enable KPI chart enhancements',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isContextBookPrefetchEnabled: {
        name: 'isContextBookPrefetchEnabled',
        description: 'Flag to enable prefetch ContextBook api',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableNewViewsAndInfoIconInDataPanelV2: {
        name: 'enableNewViewsAndInfoIconInDataPanelV2',
        description: 'Flag to enable new views and column info icon in data panel v2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableNewMutedAlertAndErrorDetailsModal: {
        name: 'enableNewMutedAlertAndErrorDetailsModal',
        description: 'Flag to enable new designs of muted alert and error details modal',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableMandatoryColumns: {
        name: 'enableMandatoryColumns',
        description: 'Flag to enable the mandatory columns feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableStrictDateColumns: {
        name: 'enableStrictDateColumns',
        description: 'Flag to enable the strict date columns feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableStrictDateColumnsByDefault: {
        name: 'enableStrictDateColumnsByDefault',
        description: 'Flag to enable the strict date columns feature by default',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableRestrictedTimeBuckets: {
        name: 'enableRestrictedTimeBuckets',
        description: 'Flag to enable the restricted time buckets feature',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableFutureDateFilterKeywords: {
        name: 'disableFutureDateFilterKeywords',
        description: 'Flag to disable fultre date filter keywords',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideRollingDateFilterSection: {
        name: 'hideRollingDateFilterSection',
        description: 'Flag to hide rolling date filter section',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isAiHighlightsSplashScreenEnabled: {
        name: 'isAiHighlightsSplashScreenEnabled',
        description: 'Flag to enable/disable AI Hightlights Splash screen modal',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    isNarrowCurrencySymbolEnabled: {
        name: 'isNarrowCurrencySymbolEnabled',
        description: 'Enable narrow currency symbol for currencys',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    narrowCurrencyCodes: {
        name: 'narrowCurrencyCodes',
        description: 'Currencies configured to display in narrow mode',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    enableAdvancedPivotTable: {
        name: 'enableAdvancedPivotTable',
        description: 'Enable pivot table 2.0.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAnomalyV2: {
        name: 'enableAnomalyV2',
        description: 'Flag to enable/disable anomaly V2 UI',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableKPIWithAnomalyV2: {
        name: 'enableKPIWithAnomalyV2',
        description: 'Flag to enable/disable kpi with anomaly V2 UI',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableKpiV2: {
        name: 'enableKpiV2',
        description: 'Flag to enable the optimised KPI V2 chart implementation',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableLbSequentialVizMount: {
        name: 'enableLbSequentialVizMount',
        description: 'Flag to enable sequential viz tile mounting on liveboards',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableFullAIHighlightsModal: {
        name: 'enableFullAIHighlightsModal',
        description: 'Flag to enable/disable full AI Highlights modal',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isForecastIncompletePointsHidden: {
        name: 'isForecastIncompletePointsHidden',
        description: 'Flag to enable/disable incomplete period points on Forecast Chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableRevampedCCAModal: {
        name: 'enableRevampedCCAModal',
        description: 'Flag to enable the revamped Contextual change analysis modal',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    showChartAggregatedValOnKPI: {
        name: 'showChartAggregatedValOnKPI',
        description: 'Flag to enable/disable chart aggregated value on KPI Chart for Apple',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableGenericCustomCompare: {
        name: 'enableGenericCustomCompare',
        description: 'Flag to enable/disable Generic Custom Comparison for KPI Charts',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isLiveboardScheduleEmailRecipientEnabled: {
        name: 'isLiveboardScheduleEmailRecipientEnabled',
        description: 'Flag to enable/disable email recipients in Liveboard Schedules',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardPermissionV2Enabled: {
        name: 'isLiveboardPermissionV2Enabled',
        description: 'Enable Liveboard  Permission v2(navan)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAnswerLevelCohorts: {
        name: 'enableAnswerLevelCohorts',
        description: 'Flag to enable/disable answer level cohorts',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    showDataPanelV2Switcher: {
        name: 'showDataPanelV2Switcher',
        description: 'Flag to enable/disable data panel v1/v2 switcher in user preferences',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isEnhancedLiveboardInteractivityWithCSREnabled: {
        name: 'isEnhancedLiveboardInteractivityWithCSREnabled',
        description: 'Enable Liveboard permission v2 with CSR',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardTileGroupingEnabled: {
        name: 'isLiveboardTileGroupingEnabled',
        description: 'Enable Liveboard Tile Grouping',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableRedirectionLinksInNewTab: {
        name: 'disableRedirectionLinksInNewTab',
        description: 'Flag to disable links',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableVisualEmbedV2Playground: {
        name: 'enableVisualEmbedV2Playground',
        description: 'Flag to enable visual embed v2 playground',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
    enableAskSageRightPanel: {
        name: 'enableAskSageRightPanel',
        description: 'Flag to disable links',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    defaultNumberFormatUnitNone: {
        name: 'defaultNumberFormatUnitNone',
        description: 'Enable Number formatting to "None" from "Auto" for measures',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    isDynamicTitleSupported: {
        name: 'isDynamicTitleSupported',
        description: 'Flag to to enable Dynamic title',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableHostedChartSameOriginSafari: {
        name: 'enableHostedChartSameOriginSafari',
        description: 'Flag to enable or disable same-origin mode for hosted charts in Safari browser',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableAboutInstanceModal: {
        name: 'enableAboutInstanceModal',
        description: 'Flag to enable or disable the About Instance modal in the top navigation help menu',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMuzeStudio: {
        name: 'enableMuzeStudio',
        description: 'Flag to enable or disable muze-studio chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeStudioRowsLimit: {
        name: 'muzeStudioRowsLimit',
        description: 'Flag to indicate rows limit for muze studio chart type',
        type: 'number',
        isListed: false,
        defaultValue: 20000,
    },
    muzeStudioAiEnabled: {
        name: 'muzeStudioAiEnabled',
        description: 'Flag to enable/disable muze studio ai',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMuzeAiChat: {
        name: 'enableMuzeAiChat',
        description: 'Flag to enable/disable the Muze AI chat panel',
        type: 'boolean',
        isListed: false,
        defaultValue: false,
    },
    enableClientSideMnMvCalculation: {
        name: 'enableClientSideMnMvCalculation',
        description: 'Flag to enable or disable client-side MN/MV calculation',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeDonutChartEnabled: {
        name: 'muzeDonutChartEnabled',
        description: 'Flag to enable Muze donut chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeCandlestickChartEnabled: {
        name: 'muzeCandlestickChartEnabled',
        description: 'Flag to enable Muze candlestick chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeScatterChartEnabled: {
        name: 'muzeScatterChartEnabled',
        description: 'Flag to enable Muze scatter chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeBubbleChartEnabled: {
        name: 'muzeBubbleChartEnabled',
        description: 'Flag to enable Muze bubble chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeHeatmapChartEnabled: {
        name: 'muzeHeatmapChartEnabled',
        description: 'Flag to enable Muze heatmap chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeWaterfallChartEnabled: {
        name: 'muzeWaterfallChartEnabled',
        description: 'Flag to enable Muze waterfall chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeParetoChartEnabled: {
        name: 'muzeParetoChartEnabled',
        description: 'Flag to enable Muze pareto chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    muzeFunnelChartEnabled: {
        name: 'muzeFunnelChartEnabled',
        description: 'Flag to enable Muze funnel chart',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    orgPerCustomEmbedUrl: {
        name: 'orgPerCustomEmbedUrl',
        description: 'Flag to add org override query param to TSE custom links',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    overrideStringIDsUrl: {
        name: 'overrideStringIDsUrl',
        description: 'Flag to add string overrides url via query param',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    overrideNullWithValue: {
        name: 'overrideNullWithValue',
        description: 'Override null with custom value',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    overrideEmptyWithValue: {
        name: 'overrideEmptyWithValue',
        description: 'Override Empty with custom value',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    isCustomerLLMAccount: {
        name: 'isCustomerLLMAccount',
        description: 'Flag to determine if customer llm account',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    aiModelType: {
        name: 'aiModelType',
        description: 'llm provider selected',
        type: 'string',
        isListed: false,
        defaultValue: undefined,
    },
    enableInferCurrencyFromBrowserAtViz: {
        name: 'enableInferCurrencyFromBrowserAtViz',
        description: 'Flag to allow infer from browser option for currency at viz level',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    zeroDecimalCurrencies: {
        name: 'zeroDecimalCurrencies',
        description: 'Flag to get currency list configured for no decimals.',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    shouldQueryDataWithSetTMLString: {
        name: 'shouldQueryDataWithSetTMLString',
        description: 'Flag to enable/disable data query with setTMLString',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAddKpiToWatchlistFromMenu: {
        name: 'enableAddKpiToWatchlistFromMenu',
        description: 'Flag to enable/disable adding KPI to watchlist from Liveboard/Answer',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableRerunQuery: {
        name: 'enableRerunQuery',
        description: 'Flag to enable/disable rerunning a search query on clicking GO button.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableQueryCancellationFeature: {
        name: 'enableQueryCancellationFeature',
        description: 'Flag to enable/disable cancellation of running data queries in search data page.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableStopAnswerGeneration: {
        name: 'enableStopAnswerGeneration',
        description: 'Flag to enable/disable stop answer generation in Spotter.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isShareChatEnabled: {
        name: 'isShareChatEnabled',
        description: 'Flag to enable/disable share chat in conv-assist (Spotter).',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isDynamicAnswerNameEnabled: {
        name: 'isDynamicAnswerNameEnabled',
        description: 'Flag to to enable Dynamic title for answers and description',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableGroupSubscriptionsInMonitor: {
        name: 'enableGroupSubscriptionsInMonitor',
        description: 'Flag to enable/disable Group subscription in monitor',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    changeAnalysisInMonitorAlerts: {
        name: 'changeAnalysisInMonitorAlerts',
        description: 'Flag to enable/disable change analysis in monitor alerts',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableMonitorListBulkSelection: {
        name: 'enableMonitorListBulkSelection',
        description: 'Flag to enable/disable bulk selection in monitor list',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    combineMultipleQueriesForCustomChart: {
        name: 'combineMultipleQueriesForCustomChart',
        description: 'Flag to enable/disable combine multiple queries in data request for custom charts.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableTSEOnboarding: {
        name: 'enableTSEOnboarding',
        description: 'Enable the custom onboarding experience in TSE',
        type: 'boolean',
        defaultValue: undefined,
        isListed: true,
    },
    smartSortV2Enabled: {
        name: 'smartSortV2Enabled',
        description: 'Flag to control the custom sort v2.',
        type: 'boolean',
        isListed: false,
        defaultValue: undefined,
    },
    enableOnlyWebhookForAlertCreation: {
        name: 'enableOnlyWebhookForAlertCreation',
        description: 'Flag to enable only webhook as the notification channel in monitor create/edit modal',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    comsChannelAsWebhookEnabled: {
        name: 'comsChannelAsWebhookEnabled',
        description: "Flag to enable communication via COMS's Webhook channel",
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableFreeTrialV2Experience: {
        name: 'enableFreeTrialV2Experience',
        description: 'Flag to enable/disable the free trial v2 experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableTeamsAdminTab: {
        name: 'enableTeamsAdminTab',
        description: 'Flag to enable/disable the teams admin tab',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableTSEV2Experience: {
        name: 'enableTSEV2Experience',
        description: 'Flag to enable/disable the tse v2 experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    hideChartComponentsForSmallViewport: {
        name: 'hideChartComponentsForSmallViewport',
        description: 'Flag to control chart component on small viewport',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableUnifiedHorizontalScrollbar: {
        name: 'enableUnifiedHorizontalScrollbar',
        description: 'Flag to enable the unified horizontal scrollbar in charts',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    freeTrialOnboardingSeen: {
        name: 'freeTrialOnboardingSeen',
        description: 'Flag to enable/disable the free trial onboarding',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isLiveboardXLSXCSVDownloadEnabled: {
        name: 'isLiveboardXLSXCSVDownloadEnabled',
        description: 'Enable Liveboard level XLSX/CSV download',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCentralizedLiveboardFilterUXEnabled: {
        name: 'isCentralizedLiveboardFilterUXEnabled',
        description: 'Enable Liveboard filter UX V2',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableRegisterAMAButton: {
        name: 'enableRegisterAMAButton',
        description: 'Flag to enable/disable the register for AMA button in the playground',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isObjectPublishingEnabled: {
        name: 'isObjectPublishingEnabled',
        description: 'Flag to enable/disable metadata object publishing UI experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isVariablesUIEnabled: {
        name: 'isVariablesUIEnabled',
        description: 'Flag to enable/disable variables UI experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCustomBanners: {
        name: 'enableCustomBanners',
        description: 'Flag to enable/disable custom banner announcements functionality',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableHomepageAnnouncement: {
        name: 'enableHomepageAnnouncement',
        description: 'Flag to enable/disable homepage announcement',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    isCommandPaletteEnabled: {
        name: 'isCommandPaletteEnabled',
        description: 'Flag to enable/disable command palette',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    automaticTranslationOfObjectMetadata: {
        name: 'automaticTranslationOfObjectMetadata',
        description: 'Flag to enable/disable automatic translation of object metadata',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    manualTranslationOfObjectMetadata: {
        name: 'manualTranslationOfObjectMetadata',
        description: 'Flag to enable/disable manual translation of user generated content',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    disableLiveboardTranslation: {
        name: 'disableLiveboardTranslation',
        description: 'Flag to disable dynamic translation on liveboard level',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    enableSourcesPagination: {
        name: 'enableSourcesPagination',
        description: 'Flag to enable/disable pagiantion in sources selection.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    formVariantValue: {
        name: 'formVariantValue',
        description: 'Flag to enable/disable form variant values sparkflow selection screen',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    sparkflowUseCaseBasedOnboardingVariantValue: {
        name: 'sparkflowUseCaseBasedOnboardingVariantValue',
        description: 'Overrides the use-case based onboarding variant for Sparkflow',
        type: 'string',
        isListed: true,
        defaultValue: undefined,
    },
    enableLayoutOptimizations: {
        name: 'enableLayoutOptimizations',
        description: 'Enable layout optimizations including IntersectionObserver-based viewport checks ' +
            'and reduced layout thrashing',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableSafariOptimization: {
        name: 'enableSafariOptimization',
        description: 'Enable Safari-specific embed optimizations (Safari only), forcing a ' +
            'full page reload on navigation instead of a hash-only update',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableKpiRenderOptimization: {
        name: 'enableKpiRenderOptimization',
        description: 'Enable optimized rendering path for lightweight KPI charts',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    muzeChartPhase1Enabled: {
        name: 'muzeChartPhase1Enabled',
        description: 'Flag to enable/disable muze chart EA phase 1.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    muzeChartPhase1EnabledGA: {
        name: 'muzeChartPhase1EnabledGA',
        description: 'Flag to enable/disable muze chart GA phase 1.',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enhancedUserEmailValidationEnabled: {
        name: 'enhancedUserEmailValidationEnabled',
        description: 'Flag to enable/disable enhanced user email validation',
        type: 'boolean',
        isListed: true,
        defaultValue: true,
    },
    adminModernExperienceEnabled: {
        name: 'adminModernExperienceEnabled',
        description: 'Flag to enable/disable the admin modern experience',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    adminFeatureManagementEnabled: {
        name: 'adminFeatureManagementEnabled',
        description: 'Flag to enable/disable New Admin Feature Management',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    adminRoutingEnabled: {
        name: 'adminRoutingEnabled',
        description: 'Flag to enable/disable URL-based routing in Admin portal',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    radiantThemeEnabled: {
        name: 'radiantThemeEnabled',
        description: 'Flag to enable the radiant design-system theme engine',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    impersonationEnabled: {
        name: 'impersonationEnabled',
        description: 'Flag to enable impersonation',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    tableIndexingModalEnabled: {
        name: 'tableIndexingModalEnabled',
        description: 'Enable the table indexing modal in the worksheet UI',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    deferLayoutWithRaf: {
        name: 'deferLayoutWithRaf',
        description: 'Defer synchronous layout reads via requestAnimationFrame',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    frontendTracingEnabled: {
        name: 'frontendTracingEnabled',
        description: 'Flag to enable enable frontend tracing',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enablePreloadVizAssets: {
        name: 'enablePreloadVizAssets',
        description: 'Preload Chart Viz Assets parallel to LoadContextBook API',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableAutoAiContextOnSpotterEnable: {
        name: 'enableAutoAiContextOnSpotterEnable',
        description: 'Auto-generate AI context when Spotter is enabled on a model',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    canCreateLiveboard: {
        name: 'canCreateLiveboard',
        description: 'Force the canCreateLiveboard RBAC v2 gate (e2e only)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    canCreateAnswers: {
        name: 'canCreateAnswers',
        description: 'Force the canCreateAnswers RBAC v2 gate (e2e only)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    canAnalyzeData: {
        name: 'canAnalyzeData',
        description: 'Force the canAnalyzeData RBAC v2 gate (e2e only)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    canAdministerSchedules: {
        name: 'canAdministerSchedules',
        description: 'Force the canAdministerSchedules RBAC v2 gate (e2e only)',
        type: 'boolean',
        isListed: true,
        defaultValue: undefined,
    },
    enableCustomerBenchmark: {
        name: 'enableCustomerBenchmark',
        description: 'If true, the Benchmark surface is available',
        type: 'boolean',
        isListed: true,
        defaultValue: false,
    },
};
//# sourceMappingURL=flags.const.js.map